/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable jsx-a11y/media-has-caption */
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import ReactPlayer from 'react-player';
import classNames from 'classnames';
import { BASE_URL, IMAGE_PATHS, VIDEO_PATHS } from '../../../../constants/paths.constants';
import { yellow, universalStyles } from '../../../../app/theme';

const useStyles = makeStyles(() => ({
  ...universalStyles,
  container: {
    width: 'calc(100% + 160px)',
    display: 'flex',
    flexDirection: 'row',
  },
  columnContainer: {
    width: '100%',
  },
  column0: {
    width: '3%',
  },
  column1: {
    width: '25%',
    marginRight: '1%',
  },
  column2: {
    width: '38%',
    marginRight: '1%',
  },
  column3: {
    width: '35%',
  },
  image: {
    width: '100%',
  },
  smallImage: {
    width: '80%',
    marginLeft: '10%',
  },
  video: {
    maxHeight: 435,
    aspectRatio: '.48',
    marginLeft: 'auto',
    marginRight: 'auto',
    display: 'block',
    height: '100%',
  },
  figureBox: {
    border: `2px solid ${yellow}`,
    width: '100%',
    boxSizing: 'border-box',
    padding: '3px 5px',
    margin: '5px 0 10px',
  },
  row: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
  },
  imageRow: {
    alignItems: 'stretch',
    '& > div': {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-end',
    },
  },
  key: {
    width: '80%',
    marginLeft: 15,
  },
  text: {
    fontSize: 16,
    lineHeight: 1.2,
    marginTop: 8,
    '&:first-of-type': {
      marginTop: 0,
    },
  },
}));

const Acquisition04 = (): JSX.Element => {
  const classes = useStyles();

  return (
    <>
      <div className={classes.container}>
        <div className={classes.columnContainer}>
          <div className={classNames(classes.row, classes.imageRow)}>
            <div className={classes.column0}>
              <img src={`${BASE_URL}${IMAGE_PATHS.SUV.path}`} alt={IMAGE_PATHS.SUV.alt} />
            </div>
            <div className={classes.column1}>
              <div className={classes.video}>
                <ReactPlayer className={classes.responsiveVideo} url={VIDEO_PATHS.ACQ_CASE_STUDY_4.path} controls />
              </div>
            </div>
            <div className={classes.column2}>
              <img
                className={classes.smallImage}
                src={`${BASE_URL}${IMAGE_PATHS.LEFT_INTERNAL.path}`}
                alt={IMAGE_PATHS.LEFT_INTERNAL.alt}
              />
            </div>
            <div className={classes.column3}>
              <img
                className={classes.image}
                src={`${BASE_URL}${IMAGE_PATHS.BONE_RIGHT.path}`}
                alt={IMAGE_PATHS.BONE_RIGHT.alt}
              />
            </div>
          </div>
          <div className={classes.row}>
            <div className={classes.column0} />
            <div className={classes.column1}>
              <div className={classes.figureBox}>
                <Typography variant="body1" className={classes.text}>
                  <b>Fig 1: </b>
                  MIP (Click to Play)
                </Typography>
              </div>
            </div>
            <div className={classes.column2}>
              <div className={classes.figureBox}>
                <Typography variant="body1" className={classes.text}>
                  <b>Fig 2: </b>
                  Left internal iliac lymph node uptake
                </Typography>
                <Typography variant="body1" className={classes.text}>
                  PET only (top) transaxial and PET/CT (bottom) transaxial images
                </Typography>
                <Typography variant="body1" className={classNames(classes.text, classes.row)}>
                  <span className={classes.key}>
                    Lymph Node SUV(bw)
                    <sub>max</sub>:
                  </span>
                  3.7
                </Typography>
                <Typography variant="body1" className={classNames(classes.text, classes.row)}>
                  <span className={classes.key}>
                    Marrow (L3) SUV(bw)
                    <sub>mean</sub>:
                  </span>
                  2.9
                </Typography>
              </div>
            </div>
            <div className={classes.column3}>
              <div className={classes.figureBox}>
                <Typography variant="body1" className={classes.text}>
                  <b>Fig 3: </b>
                  Bone right ilium uptake
                </Typography>
                <Typography variant="body1" className={classes.text}>
                  PET/CT transaxial image
                </Typography>
                <Typography variant="body1" className={classNames(classes.text, classes.row)}>
                  <span className={classes.key}>
                    Lymph Node SUV(bw)
                    <sub>max</sub>:
                  </span>
                  4.3
                </Typography>
                <Typography variant="body1" className={classNames(classes.text, classes.row)}>
                  <span className={classes.key}>
                    Marrow (L3) SUV(bw)
                    <sub>mean</sub>:
                  </span>
                  2.9
                </Typography>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Acquisition04;
